import { call, put, takeLatest } from 'redux-saga/effects'
import { getDrivers } from '../../firebase-services/db-services';
import { getDriversSuccess } from '../slices/driverState';
function* async_getDriverFetch() {
        
        const drivers = yield call(()=>getDrivers());
        const formattedDrivers = yield drivers.docs;
        //console.log({filter,Party})
        const driverData = formattedDrivers.map(doc =>{
            return {...doc.data(),docid:doc.id}
        } )
        yield put(getDriversSuccess(driverData))
        
}
function* driverSaga() {
    yield takeLatest('drivers/getDriversFetch', async_getDriverFetch);
}
export default driverSaga;